import { AnexoEnum, AnexoPautaType } from 'helpers/enums/anexoPauta';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { TextRange } from 'helpers/utils/StringUtils';
import {
  DEFAULT_VALID,
  DEFAULT_VALIDATION_MODEL,
} from 'helpers/utils/ValidationUtils';
import urlParser from 'js-video-url-parser';
import translation from 'locales/translation';
import {
  AddCircleIcon,
  Button,
  ButtonThemes,
  Checkbox,
  CloudUploadIcon,
  Col,
  Collapse,
  ControlLabel,
  Input,
  Row,
  TimesCircleIcon,
  useValidatedState,
} from 'plataforma-fundacao-componentes';
import { useEffect, useState } from 'react';
import { useStyles } from './styles';

interface Props {
  anexo?: AnexoPautaType;
  onAdd: (a: AnexoPautaType) => void;
  onCancel: () => void;
}

const DESC_LIMIT = { [AnexoEnum.DOCUMENTO]: 300, [AnexoEnum.VIDEO]: 200 };

export default function PreAnexoPautaItem(props: Props) {
  const classes = useStyles();
  const [sent, setSent] = useState(false);

  const [visivelAssociado, setVisivelAssociado] = useState<boolean>(true);

  const [urlFileName, setUrlFileName, urlValidation] = useValidatedState(
    (url) => {
      if (props.anexo?.tipoAnexo === AnexoEnum.DOCUMENTO) return DEFAULT_VALID;

      if (!url) {
        return DEFAULT_VALIDATION_MODEL(
          true,
          translation.AnexoPautaItem.urlObrigatoria
        );
      }
      const parsedUrl = urlParser.parse(url!);
      if (!parsedUrl || !parsedUrl.provider || !parsedUrl.id) {
        return DEFAULT_VALIDATION_MODEL(
          true,
          translation.AnexoPautaItem.urlInvalida
        );
      }
      if (parsedUrl.provider !== 'youtube' && parsedUrl.provider !== 'vimeo') {
        return DEFAULT_VALIDATION_MODEL(
          true,
          translation.AnexoPautaItem.informeLink
        );
      }

      return DEFAULT_VALID;
    },
    props.anexo?.tipoAnexo === AnexoEnum.DOCUMENTO
      ? props.anexo?.file?.name
      : props.anexo?.url ?? ''
  );

  const [descricao, setDescricao] = useState(props.anexo?.descricao || '');

  useEffect(() => {
    setSent(false);
    setDescricao('');
    setVisivelAssociado(true);
    if (props.anexo) {
      if (props.anexo.tipoAnexo === AnexoEnum.DOCUMENTO) {
        setUrlFileName(props.anexo.file?.name ?? '');
      } else {
        setUrlFileName(props.anexo.url || '');
      }
    } else {
      setUrlFileName('');
      setVisivelAssociado(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.anexo]);

  return (
    <Collapse opened={Boolean(props.anexo)} animateOpacity>
      <Row className={classes.root}>
        <Row style={{ padding: '16px' }}>
          <Col className={classes.title}>
            <span>
              {translation.AnexoPautaItem.adicionar}
              {/* {t(
                `AnexoPautaItem.adicionar${
                  props.anexo?.tipoAnexo === AnexoEnum.VIDEO
                    ? 'Video'
                    : 'Documento'
                }`
              )} */}
            </span>
          </Col>
          <Col>
            {props.anexo?.tipoAnexo === AnexoEnum.DOCUMENTO ? (
              <div className={classes.nomeDocumento}>
                <CloudUploadIcon />
                {urlFileName}
              </div>
            ) : (
              <Input
                label={translation.AnexoPautaItem.url}
                value={urlFileName}
                placeholder={'Insira a URL'}
                onChange={(e) => {
                  setUrlFileName(e.target.value);
                }}
                maxLength={200}
                counter={true}
                data-testid={'document-url'}
                error={sent && urlValidation.error}
                helperText={sent ? urlValidation.text : ''}
              />
            )}
          </Col>
          <Col noPaddingTop>
            <Input
              label={translation.AnexoPautaItem.descricao}
              value={descricao}
              placeholder={'Sem descrição'}
              onChange={(e) => {
                setDescricao(
                  TextRange(
                    e.target.value,
                    DESC_LIMIT[props.anexo?.tipoAnexo!] || 200
                  )
                );
              }}
              disabled={false}
              maxLength={300}
              counter={true}
              data-testid={'document-description'}
            />
          </Col>
          <Col style={{ marginTop: '-8px' }}>
            <ControlLabel
              label={translation.AnexoPautaItem.visivelLabel}
              control={
                <Checkbox
                  value={visivelAssociado}
                  onChange={(c) => {
                    setVisivelAssociado(c);
                  }}
                />
              }
            />
          </Col>
          <Col className={classes.addButton} buttonActionsCol end>
            <Button
              leftIcon={<TimesCircleIcon />}
              theme={ButtonThemes.Secondary}
              onClick={props.onCancel}
            >
              Cancelar
            </Button>
            <Button
              leftIcon={<AddCircleIcon />}
              onClick={() => {
                setSent(true);
                if (!props.anexo || !urlFileName || urlValidation.error) {
                  return;
                }
                setSent(false);
                props.onAdd({
                  ...props.anexo,
                  url:
                    props.anexo?.tipoAnexo === AnexoEnum.VIDEO
                      ? urlFileName
                      : '',
                  descricao,
                  flgDisponivelAssociado: visivelAssociado,
                  idTemporarioFront: parseInt(
                    getUniqueKey().replaceAll(/\D/g, '')
                  ),
                });
              }}
              disabled={sent && (!urlFileName || urlValidation.error)}
            >
              {translation.AnexoPautaItem.adicionar}
            </Button>
          </Col>
        </Row>
      </Row>
    </Collapse>
  );
}
